import React, {Component} from 'react'
import Cannonicalize from '../Cannonicalize'
import ClientSideCacheController from '../ClientSideCacheController'
import Tile from '../Tile'
import Analytics from '../Analytics';

class LayoutOneTwoThree extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    //all the import links are set from the config file
    this.affiliate = props.affiliate;
    this.state = Cannonicalize.category()
    this.maxStories = 6
    this.categoryId = props.categoryId || props.params.id
    this.showTitle = props.showTitle
    this.contentClassification = ''
  }
  componentWillMount() {

    try {
      this.setState(  Cannonicalize.category(this.props.FRN_rawResponses[0].data))
    } catch (e) {
      e.message += ' in LayoutOneTwoThree for category # ' + this.categoryId
      Analytics.reportError(e)
    }
    if (typeof window !== 'object')
      return

    ClientSideCacheController.get('category', {id: this.categoryId}).then((res) => {
      this.setState(res)
    })

  }

  componentDidMount() {
    if(!this.props.idsToShowAds)
      return null
    try{
      let config = JSON.parse(this.props.idsToShowAds)
      if(!(this.categoryId.toString() in config))
        return null //not on the right page
      this.contentClassification = config[this.categoryId.toString()]
    } catch(e){
      console.log(e)
    }

      window.gptadslots = window.gptadslots || [];
      window.googletag = window.googletag || {
        cmd: []
      };

      googletag.cmd.push(() =>{
        console.log('Layout One Two Three ad created ad %s', '/43459271/loc-desktop/'+ this.props.affiliate+ '/web/' + this.contentClassification)
        gptadslots.push(googletag.defineSlot('/43459271/loc-desktop/'+ this.props.affiliate+ '/web/' + this.contentClassification,
        [[1, 1]],'gnm-layout-one-two-three-ad').addService(googletag.pubads()));

        googletag.pubads().enableSingleRequest();
        googletag.enableServices();
      });
      window.googletag.cmd.push(function() {
        googletag.display('gnm-layout-one-two-three-ad')
      });
  }


  render() { // REQUIRED
    try {
      if (this.state.features.length < 1)
        return null
      return (
        <div className='gnm-layout-one-two-three' onClick={()=>Analytics.homePageClickTracker(this.props.title)}>
          <div className="row">
            <h2 className="col-xs-12 h4 white-at-small">
              <span>{this.showTitle ? (this.props.title || this.state.headline): ''}</span>
              <span id='gnm-layout-one-two-three-ad' className="customAdTag"></span>
            </h2>

            {this.state.features.slice(0, 1).map(function(s,i,a){
             return(
               <div className="col-xs-12 feature" key={i}>
                 <Tile story={s} gradient={true} width={1024} height={575} />
               </div>
             )
            })}
          </div>
          <div className='row'>
            {this.state.features.slice(1, 3).map(function(s,i,a){
              return (
                <div className="col-md-6" key={i}>
                  <Tile story={s}  gradient={true}/>
                </div>
              )
            })}
          </div>
          <div className='row'>
            {this.state.features.slice(3, 6).map(function(s,i,a){
              return (
                <div className="col-md-4 " key={i} >
                  <Tile story={s} />
                </div>
              )
            })}
          </div>
          <div className="col-xs-12 hidden-md hidden-lg hidden-xl text-center">
            <a className="btn btn-default" href={'/category/'+this.props.categoryId+ '/top-stories'} role="button">View More Stories</a>
          </div>
        </div>
      )
    } catch (e) {
      e.message += ' render failure in LayoutOneTwoThree for category #'+this.categoryId
      Analytics.reportError(e)
      return null
    }
  }
}

export default LayoutOneTwoThree



// WEBPACK FOOTER //
// ./app/components/custom/ssr/LayoutOneTwoThree/index.js